// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"church"},"children":[{"tag":"path","attrs":{"id":"fill1","fill":"props.fillColor1","d":"M17 10V13H21V21H3V13H7V10L12 6.5L17 10Z"}},{"tag":"path","attrs":{"id":"fill2","fill":"props.fillColor2","d":"M14 21V16C14 14.8954 13.1046 14 12 14C10.8954 14 10 14.8954 10 16V21H14Z"}},{"tag":"path","attrs":{"id":"stroke2","stroke":"props.strokeColor2","d":"M14 21V16C14 14.8954 13.1046 14 12 14C10.8954 14 10 14.8954 10 16V21H14Z","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}},{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M17 13H21V21H17M17 13V21M17 13V10L12 6.5M17 21H7M12 6.5L7 10V13M12 6.5V4M7 13H3V21H7M7 13V21M12 2V4M12 4H14M12 4H10","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const ChurchIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'church',
    ref,
    icon: element,
  },
));

ChurchIcon.displayName = 'ChurchIcon';

export default ChurchIcon;
